import * as React from 'react';

// Exports
export const DefaultErrorRoute = () => (
  // !TODO @eldarshamukhamedov Replace placeholder with a generic error page design
  <div>Something went wrong</div>
);
